import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute"; // <- Make sure path is correct

import Signup from "../pages/auth/Signup";
import Signin from "../pages/auth/Signin";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ManageRobot from "../pages/manage-robot";
import Chat from "../pages/chat/Chat";
import ManageMemory from "../pages/manage-memory";
import ValidateToken from "../pages/auth/ValidateToken";
import UserManagement from "../pages/user/UserManagement";
import UserProfile from "../pages/user/UserProfile";
import { useEffect, useState } from "react";
import VerificationConfirm from "../pages/auth/VerificationConfirm";

const AppRoutes = () => {
  const metaData = useSelector((state: any) => state.metaData);
  const token = metaData?.userInfo?.token;
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  // Wait for the app to be ready (e.g., token loaded from localStorage)
  useEffect(() => {
    setIsReady(true);
  }, [token]);

  if (!isReady) return null; // Or loading spinner

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/signin"
        element={
          token ? (
            <Navigate to={location.state?.from?.pathname || "/chat"} replace />
          ) : (
            <Signin />
          )
        }
      />
      <Route
        path="/signup"
        element={token ? <Navigate to="/" /> : <Signup />}
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/validate-token" element={<ValidateToken />} />
      <Route path="/verification-confirm" element={<VerificationConfirm />} />

      {/* Private Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Chat />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/manage-robot/:id?" element={<ManageRobot />} />
        <Route path="/manage-memory" element={<ManageMemory />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/user-profile" element={<UserProfile />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<h1>Page not found</h1>} />
    </Routes>
  );
};

export default AppRoutes;
